import { useMutation } from '@tanstack/react-query'

import { useMe } from '@shared/providers/src/MeProvider'
import { setQueriesData } from '@shared/providers/src/QueryClientProvider'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export function useProfileUpdate() {
  const me = useMe()

  return useMutation({
    mutationFn: (data) => API.users.id(me.id).update(data),
    onSuccess: (response) => {
      return setQueriesData({ queryKey: QK.me(me.id).details }, (current) => ({ ...current, ...response }))
    },
  })
}
